module.exports = __webpack_public_path__ + "static/media/logo-aulao-presencial.2ce282c4.png";